import React from 'react'

const utilitiesRoutes = [
    {
        path: '/:siteId/utilities/color',
        component: React.lazy(() => import('./Color')),
    },
    {
        path: '/:siteId/utilities/spacing',
        component: React.lazy(() => import('./Spacing')),
    },
    {
        path: '/:siteId/utilities/typography',
        component: React.lazy(() => import('./Typography')),
    },
    {
        path: '/:siteId/utilities/display',
        component: React.lazy(() => import('./Display')),
    },
    {
        path: '/:siteId/utilities/height-width',
        component: React.lazy(() => import('./HeightWidth')),
    },
    {
        path: '/:siteId/utilities/position',
        component: React.lazy(() => import('./Position')),
    },
    {
        path: '/:siteId/utilities/shadow',
        component: React.lazy(() => import('./Shadow')),
    },
    {
        path: '/:siteId/utilities/misc',
        component: React.lazy(() => import('./MiscClass')),
    },
]

export default utilitiesRoutes
